import CloudSyncOutlined from '@ant-design/icons/lib/icons/CloudSyncOutlined';
import Alert from 'antd/lib/alert';
import { getComputerFormattedTime } from 'src/domain/date/date';
import { SyncStatus } from 'src/domain/pjm/dto/SyncStatus';

type PjmSyncStatusDetailedProps = {
    value: {
        syncDrhubStatus: SyncStatus;
        syncDrhubDate?: Date;
        syncDrhubError?: string;
    };
};

export function PjmSyncStatusDetailed({ value }: PjmSyncStatusDetailedProps) {
    return (
        <Alert
            message={
                <>
                    Sync with PJM DRHUB: <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>{value.syncDrhubStatus || ''}</span>{' '}
                    {value.syncDrhubDate ? 'at ' + getComputerFormattedTime(value.syncDrhubDate) : ''}
                </>
            }
            description={value.syncDrhubError ? <div>{value.syncDrhubError}</div> : undefined}
            type={value.syncDrhubStatus === SyncStatus.FAILED ? 'error' : 'info'}
            showIcon
            icon={<CloudSyncOutlined style={{ fontSize: '24px' }} />}
            style={{ margin: '10px 0 20px 0' }}
        />
    );
}
